import React, { useEffect, useState } from 'react';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import $ from 'jquery';

import Menu from './Menu';
import Video from "../../components/Video";
import Animation from "../../components/Animation";
import PortfolioChatbot from "../../components/PortfolioChatbot";
import Chatbot from '../Common/Chatbot';
import VideoCarousel from "./Carousel";
import Wall from './Wall';
import Character from '../Animation/CharacterJson';
import Hologram from './Hologram';
import Banner from '../Common/Banner';
import Testimonials from '../Common/Testimonials';
import Hand from '../Common/Hand';
import Bridge from '../Animation/Bridge';
import Train from '../Animation/Train';
import Tube from '../Animation/Tube';
import Logo from '../Animation/Logo';
import Dog from '../Animation/Dog';
import Ship from '../Animation/Ship';
import Walker from '../Animation/Walker';
import Skating from '../Animation/Skating';
import Footer from '../../components/Footer';

import style from "../style.module.css";
import {
	ship1, ship2, ship3, ship4, ship5,
	cloud1, cloud3, cloud31, cloud4, cloud5, cloud6, cloud7, cloud8, cloud9, cloud10, cloud11, cloud12, cloud13,
	building1, building2, building3, building4, building5, building6,
	mp4, webm,
	bikerJson,
	mp42,
	webm2,
	coffeeJson
} from "../../assets/index";

const getComputedTranslateY = (obj) => {
	if (!obj || !window.getComputedStyle) return 0;
	const computedStyle = window.getComputedStyle(obj);
	const transform = computedStyle.transform || computedStyle.webkitTransform || computedStyle.mozTransform;
	if (!transform || transform === 'none') return 0;

	// Covers translate3d(), matrix(), and matrix3d() across modern browsers.
	if (typeof window.DOMMatrixReadOnly === "function") {
		try {
			return new window.DOMMatrixReadOnly(transform).m42 || 0;
		} catch {
			// Fall back to manual parsing below.
		}
	}

	let mat = transform.match(/^matrix3d\((.+)\)$/);
	if (mat) {
		const values = mat[1].split(',').map((item) => Number(item.trim()));
		return Number.isFinite(values[13]) ? values[13] : 0;
	}

	mat = transform.match(/^matrix\((.+)\)$/);
	if (mat) {
		const values = mat[1].split(',').map((item) => Number(item.trim()));
		return Number.isFinite(values[5]) ? values[5] : 0;
	}

	mat = transform.match(/^translate3d\(([^,]+),\s*([^,]+),\s*([^)]+)\)$/);
	if (mat) {
		const y = Number.parseFloat(mat[2]);
		return Number.isFinite(y) ? y : 0;
	}

	mat = transform.match(/^translateY\(([^)]+)\)$/);
	if (mat) {
		const y = Number.parseFloat(mat[1]);
		return Number.isFinite(y) ? y : 0;
	}

	return 0;
}

const scrollToSection = (id, { offset = -90, onComplete } = {}) => {
	const target = $('#' + id);
	if (!target.length) {
		if (typeof onComplete === 'function') {
			onComplete();
		}
		return;
	}

	$('html, body')
		.stop(true)
		.animate(
			{
				scrollTop: target.offset().top + offset
			},
			'slow',
			() => {
				if (typeof onComplete === 'function') {
					onComplete();
				}
			}
		);
}

const Desktop = () => {
	const [section, setSection] = useState(false);
	const [bot, setBot] = useState(false);
	const [video, setVideo] = useState(false);
	const [wall, setWall] = useState(false);
	const portfolioPdfUrl = process.env.REACT_APP_PORTFOLIO_PDF_URL || encodeURI(`${process.env.PUBLIC_URL || ''}/Outstandly Portfolio 2023.pdf`);
	const cloudsList = [cloud1, cloud3, cloud31, cloud4, cloud5, cloud6, cloud7, cloud8, cloud9, cloud10, cloud11, cloud12, cloud13];
	const cloudsClass = [style.cloud1, style.cloud3, style.cloud31, style.cloud4, style.cloud5, style.cloud6, style.cloud7, style.cloud8, style.cloud9, style.cloud10, style.cloud11, style.cloud12, style.cloud13];
	const onMenuClick = (id) => {
		let offset = -90;
		if (id === "quote") {
			offset = -120;
		}
		scrollToSection(id, { offset });
	};
	const onShowreelEyeballClick = () => {
		scrollToSection("showreel", {
			offset: -180,
			onComplete: () => setVideo(1)
		});
	};

	//Parallax on banner
	useEffect(() => {
		const bannerElement = document.getElementById('banner');
		const buildingElement = document.querySelector(`.${style.building}`);
		if (!bannerElement || !buildingElement) return;

		let rafId = null;
		let latestScrollY = window.scrollY || window.pageYOffset || 0;
		let lastBannerY = null;
		let lastBuildingMargin = null;

		const updateParallax = () => {
			rafId = null;

			const bannerY = Math.min(0, latestScrollY * -0.5);
			if (bannerY !== lastBannerY) {
				bannerElement.style.transform = `translateY(${bannerY}px)`;
				lastBannerY = bannerY;
			}

			const buildingMargin = Math.ceil(getComputedTranslateY(buildingElement));
			if (buildingMargin !== lastBuildingMargin) {
				buildingElement.style.marginBottom = `${buildingMargin}px`;
				lastBuildingMargin = buildingMargin;
			}
		};

		function onScroll() {
			latestScrollY = window.scrollY || window.pageYOffset || 0;
			if (rafId === null) {
				rafId = window.requestAnimationFrame(updateParallax);
			}
		}

		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();

		return () => {
			window.removeEventListener("scroll", onScroll);
			if (rafId !== null) {
				window.cancelAnimationFrame(rafId);
			}
		}
	}, [style.building]);

	return (
		<>
			<div className={`${style.page} ${style.desktop}`}>
				<Menu onClick={onMenuClick} setSection={(id) => setSection(id)} />
				<ParallaxProvider>
					<div id="banner" className={style.banner}>
						{
							cloudsList.map((item, i) => (
								<div className={`${style.cloud} ${cloudsClass[i]}`} key={i}>
									<img src={item} alt={`Cloud ${i}`} />
								</div>
							))
						}
						<Parallax className={style.object1} speed={15}>
							<img src={ship1} alt="Ship 1" />
						</Parallax>
						<Parallax className={style.object2} speed={30}>
							<img src={ship2} alt="Ship 2" />
						</Parallax>
						<Parallax className={style.object3} speed={10}>
							<img src={ship3} alt="Ship 3" />
						</Parallax>
						<Parallax className={style.object4} speed={0}>
							<img src={ship4} alt="Ship 4" />
						</Parallax>
						<Parallax className={style.object5} speed={5}>
							<img src={ship5} alt="Ship 5" />
						</Parallax>
						<div className={style.outstandlyWrap}>
							<Banner onClick={onShowreelEyeballClick} />
						</div>
					</div>
					<Parallax className={style.character} speed={20}>
						<Character />
					</Parallax>
					<Parallax className={style.building} speed={30}>
						{
							[building1, building2, building3, building4, building5, building6].map((item, i) => {
								return (
									<div className={style.buildingItem} key={i}>
										<div className={style.sizerBuilding}></div>
										<div className={style.bsz} style={{ backgroundImage: `url(${item})` }}></div>
									</div>
								)
							})
						}
						<div id="showreel" className={style.video1Wrap}>
							<div className={style.video1Angle}>
								<Video id="video1" title="SHOWREEL" mp4={mp4} webm={webm} onClick={() => setVideo(1)} />
							</div>
						</div>
						<div className={style.video2Wrap}>
							<div className={style.video2Angle}>
								<Video id="video2" html='Testimonial<br>by Bump Studios' mp4={mp42} webm={webm2} onClick={() => setVideo(2)} />
							</div>
						</div>
						<Logo />
						<Train />
						<Tube />
						<Bridge />
						<Dog />
						<Ship />
						<div className={`${style.animation} ${style.coffee}`}>
							<Animation className={style.coffeeThreshold} json={coffeeJson} loop={true} />
						</div>
						<Walker />
						<Skating />
						<div id="quote" className={`${style.animation} ${style.biker}`}>
							<Animation className={style.bikerThreshold} json={bikerJson} loop={false} onFrameReach={() => setBot(true)} />
						</div>
						<Hand />
						{
							/*<div className={`${style.animation} ${style.cars}`}>
								<Animation className={style.carsThreshold} json={carsJson} />
							</div>
							<div className={`${style.animation} ${style.fancycars}`}>
								<Animation className={style.fancycarsThreshold} json={fancycarsJson} />
							</div>*/
						}
						</Parallax>
					</ParallaxProvider>
					<Testimonials src="https://embed.testimonial.to/w/outstandly-gamedev2?animated=on&theme=dark&shadowColor=transparent" onClick={() => setWall(true)} />
					{
						bot === true && (
							<div id="landbotholder" className={style.landbotHolder}>
								<Hologram />
								<div id="landbot" className={style.landbotPosition}>
									<PortfolioChatbot
										className={style.landbot}
										portfolioPdfUrl={portfolioPdfUrl}
									/>
								</div>
							</div>
						)
					}
				{
					video !== false && (
						<VideoCarousel selected={video} onClose={() => setVideo(false)} />
					)
				}
				{
					wall === true && (
						<Wall onClose={() => setWall(false)} />
					)
				}
				{
					section === "about" && (
						<Chatbot onClose={() => setSection(false)} />
					)
				}
				{
					section === "chatbot" && (
						<Chatbot mode="portfolio" portfolioPdfUrl={portfolioPdfUrl} onClose={() => setSection(false)} />
					)
				}
			</div>
			<Footer onMenuClick={onMenuClick} />
		</>
	)
}

export default Desktop;
